/**
 * Root-level cookie banner for non-public application routes.
 *
 * Public marketing paths use {@link DeferredPublicCookieBanner} inside the
 * public Suspense boundary instead (Bug #1388).
 */

import { useLocation } from 'react-router-dom';
import { isPublicPath } from '../../constants/auth';
import { CookieBanner } from './CookieBanner';

/**
 * Shows the standard cookie banner on app/auth/admin routes; omits it on
 * public marketing URLs where defer-gated banner mounts after route commit.
 */
export const AppRootCookieBanner: React.FC = () => {
  const { pathname } = useLocation();

  if (isPublicPath(pathname)) {
    return null;
  }

  return <CookieBanner />;
};
